// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3SNP-","itemTitle":"ClientEmergencyInfo_itemTitle__3Hsqx","itemText":"ClientEmergencyInfo_itemText__21JPD"};